import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useToasts } from "../LayoutComponents/ToastContext";
import LoginForm from "../Components/LoginForm/LoginForm";
import i18n from "../Services/i18n";

const LoginPage = () => {
  const location = useLocation();
  const { addToast } = useToasts();

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(location.search);

      if (params.has("expired")) {
        addToast(i18n.t("Logout.Expired"), "SESSION_EXPIRED", "WARNING", true);
      } else if (params.has("logout")) {
        addToast(i18n.t("Logout.Logout"), "SESSION_LOGOUT", "SUCCESS", true);
      } else if (params.has("changed")) {
        addToast(i18n.t("Logout.Changed"), "SESSION_CHANGED", "SUCCESS", true);
      } else if (params.has("upgraded")) {
        addToast(i18n.t("MyAccount.Subscription.UpgradeCongrats"), "SESSION_CHANGED", "SUCCESS", true);
      }
    };

    run();
  }, [location.search, addToast]);

  return (
    <>
      <LoginForm />
    </>
  );
};

export default LoginPage;
